import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c012da8c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c012da8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c012da8c')) {
      api.createRecord('c012da8c', component.options)
    } else {
      api.reload('c012da8c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c012da8c&scoped=true&", function () {
      api.rerender('c012da8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/reports/active51/index.vue"
export default component.exports